import useTranslation from 'customHooks/translate';
import CurrencyFlag from 'react-currency-flags';

interface CurrencyItem {
  currencyId: string;
  totalAmount: number;
}
interface SummaryItem {
  totalByCurrency: CurrencyItem[];
  totalInDefaultCurrency: number;
  defaultCurrency: string;
}

interface IProps {
  title: string;
  summaryData: SummaryItem;
}

export const ExpensesSummary = ({ title, summaryData }: IProps) => {
  const translation = useTranslation();

  return (
    <div className="flex flex-col gap-[10px] p-[16px]">
      <div className="flex h-max flex-col justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">{title}</p>
        {summaryData?.totalByCurrency?.map((total, index) => (
          <div
            className="flex items-center gap-[4px] text-[16px] font-medium text-[#1D1D1D]"
            key={index}
          >
            <CurrencyFlag
              className="currency-flag"
              currency={total.currencyId}
            />
            <span>
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(total.totalAmount || 0)}{' '}
            </span>
            <span>{total.currencyId}</span>
          </div>
        ))}
      </div>
      <div className="flex h-max flex-col justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.reports.TotalExpences}
        </p>
        <div className="flex items-center gap-[4px]">
          <CurrencyFlag
            className="currency-flag"
            currency={summaryData?.defaultCurrency}
          />
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(summaryData?.totalInDefaultCurrency || 0)}{' '}
            {summaryData?.defaultCurrency}
          </p>
        </div>
      </div>
    </div>
  );
};
